export default __webpack_public_path__ + "static/media/0080.104779fe.png";